import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import Logo from '../../assets/logo.png';
import CloseIcon from '../../assets/x.svg';
import '../../styles/Header.css';

const ADMIN_LINKS = [
  { path: '/admin/programs', label: 'Programs' },
  { path: '/admin/content/exercises', label: 'Exercises' },
  { path: '/admin/content/equipment', label: 'Equipment' },
  { path: '/admin/content/warmups', label: 'Warmups' },
  { path: '/admin/content/finishers', label: 'Finishers' },
  { path: '/admin/content/drills', label: 'Drills' },
  { path: '/admin/content/workouts', label: 'Workouts' },
  { path: '/admin/clubs', label: 'Clubs' },
  { path: '/admin/docs', label: 'Docs' },
  { path: '/admin/settings', label: 'Settings' },
];

function AdminNav({ authenticated }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const pathname = location.pathname ?? '';

  const handleLogout = async () => {
    try {
      await signOut(auth);
      window.location.href = '/admin';
    } catch (err) {
      console.error('[AdminNav] Logout error:', err);
    }
  };

  const isActive = (path) => {
    if (path === '/admin/programs') {
      return pathname === '/admin' || pathname === '/admin/programs' || pathname.startsWith('/admin/programs/');
    }
    return pathname === path || pathname.startsWith(path + '/');
  };

  return (
    <header className="header visible">
      <div className="header-container">
        <div className="header-logo">
          <Link to="/admin/programs">
            <img src={Logo} alt="Begin Strength" />
          </Link>
        </div>

        <div className="hamburger-container" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? (
            <img src={CloseIcon} alt="Close" className="close-icon" />
          ) : (
            <div className="hamburger">
              <span className="bar" />
              <span className="bar" />
              <span className="bar" />
            </div>
          )}
        </div>

        <nav className={`header-nav ${menuOpen ? 'open' : ''}`}>
          <ul>
            {ADMIN_LINKS.map(({ path, label }) => (
              <li key={path}>
                <Link
                  to={path}
                  className={isActive(path) ? 'active' : ''}
                  onClick={() => setMenuOpen(false)}
                >
                  {label}
                </Link>
              </li>
            ))}
            {authenticated && (
              <li className="mobile-nav-link">
                <button
                  type="button"
                  className="header-nav-logout"
                  onClick={() => { setMenuOpen(false); handleLogout(); }}
                >
                  Logout
                </button>
              </li>
            )}
          </ul>
        </nav>

        <div className="header-buttons">
          {authenticated ? (
            <button
              type="button"
              className="c-ripple header-button header-button-login"
              onClick={handleLogout}
            >
              Logout
            </button>
          ) : (
            <span className="header-button header-button-login" style={{ cursor: 'default', opacity: 0.8 }}>
              Login
            </span>
          )}
        </div>
      </div>
    </header>
  );
}

export default AdminNav;
